import { Component, Input } from '@angular/core';
import { TwoColumnStructureComponent } from '../two-column-structure/two-column-structure.component';
import { CommonModule } from '@angular/common';
import { MiFieldsComponent } from '../mi-fields/mi-fields.component';
import { AppSettings } from '../../app.settings';

@Component({
  selector: 'app-general-settings-form',
  standalone: true,
  imports: [TwoColumnStructureComponent,
    CommonModule,
    MiFieldsComponent,
  ],
  templateUrl: './general-settings-form.component.html',
  styleUrl: './general-settings-form.component.scss'
})
export class GeneralSettingsFormComponent {

  @Input() field: any;
  @Input() attributeLabels: any;
  @Input() moduleName: string;
  @Input() dateFormat: string;
  @Input() isResetPrivilege;
  @Input() passengerTypeToReset;
  fieldsToDisplayHRLine = AppSettings.FIELDS;

  shouldDisplayHrLine(field: any): boolean {
    const hrLineFields = [
        this.fieldsToDisplayHRLine.TRIAL_NOTIFICATION_EMAIL,
        this.fieldsToDisplayHRLine.ORDER_NOTIFICATION_EMAIL,
        this.fieldsToDisplayHRLine.TRAIL_BUDGET_THRESHOLD,
        this.fieldsToDisplayHRLine.ORDER_SUPPORT_EMAIL,
    ];
    return hrLineFields.includes(field.attributeCode);
  }

}
